var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable import/no-cycle */
import React, { Fragment } from 'react';
import styled, { css } from '@empiriecom/module-components/utils/styled-components';
import cuid from 'cuid';
import useConfig from '../hooks/useConfig';
import filterTimeControl from '../../utils/filterTimeControl';
import ComponentRecognizer from '../ComponentRecognizer';
var flexValuePreparer = function (type, alignSelf) {
    if (type.match(alignSelf)) {
        return type;
    }
    if (type === 'top') {
        return 'flex-start';
    }
    if (type === 'bottom') {
        return 'flex-end';
    }
    return null;
};
var HorizontalAlignment = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var alignment = _a.alignment, justifyContent = _a.justifyContent, alignContent = _a.alignContent, textAlign = _a.textAlign;
    var additionalTextAlign = function () {
        if (alignment.match(textAlign)) {
            return "text-align: " + alignment + ";";
        }
        return '';
    };
    if (alignment.match(justifyContent)) {
        return additionalTextAlign() + " justify-content: " + alignment;
    }
    if (alignment.match(alignContent)) {
        return additionalTextAlign() + " align-content: " + alignment + ";";
    }
    return "" + additionalTextAlign();
});
var VerticalAlignment = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ",
    ";\n"])), function (_a) {
    var verticalAlignment = _a.verticalAlignment, alignSelf = _a.alignSelf;
    var hasParam = flexValuePreparer(verticalAlignment, alignSelf);
    return hasParam ? "align-self: " + hasParam + ";" : null;
});
var StyledGroup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  margin: ", ";\n  ", "\n  display: flex;\n  flex-flow: row wrap;\n  align-items: stretch;\n  height: 100%;\n  background-color: ", ";\n\n  flex-direction: ", ";\n\n  ", "\n  ", "\n\n    > div {\n    ", "\n    ", "\n      \n      &.component-recognizer-container,\n      .cms-group {\n      width: 100%;\n    }\n  }\n\n  @media only screen and (max-width: ", ") {\n    > div {\n      ", "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    flex-direction: ", ";\n\n    > div {\n      ", "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  margin: ", ";\n  ",
    "\n  display: flex;\n  flex-flow: row wrap;\n  align-items: stretch;\n  height: 100%;\n  background-color: ", ";\n\n  flex-direction: ",
    ";\n\n  ", "\n  ", "\n\n    > div {\n    ", "\n    ", "\n      \n      &.component-recognizer-container,\n      .cms-group {\n      width: 100%;\n    }\n  }\n\n  @media only screen and (max-width: ", ") {\n    > div {\n      ",
    "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  @media only screen and (min-width: ", ") {\n    flex-direction: ",
    ";\n\n    > div {\n      ",
    "\n\n      &:nth-child(", "n+0) {\n        margin-right: 0;\n      }\n    }\n  }\n\n  ",
    "\n"])), function (_a) {
    var outerMargin = _a.outerMargin;
    return outerMargin;
}, function (_a) {
    var outerPadding = _a.outerPadding;
    return outerPadding !== '0' ? "padding: " + outerPadding + ";" : null;
}, function (_a) {
    var backgroundColor = _a.backgroundColor;
    return backgroundColor;
}, function (_a) {
    var cellsPerRowPercentageMobile = _a.cellsPerRowPercentageMobile;
    return cellsPerRowPercentageMobile === 100 ? 'column' : 'row';
}, HorizontalAlignment, VerticalAlignment, HorizontalAlignment, VerticalAlignment, function (_a) {
    var mobileMaxWidth = _a.mobileMaxWidth;
    return mobileMaxWidth;
}, function (_a) {
    var cellsPerRowMobile = _a.cellsPerRowMobile, colGap = _a.colGap, rowGap = _a.rowGap;
    if (cellsPerRowMobile > 1) {
        if (colGap !== '0') {
            return "flex-basis: calc((100% - " + colGap + " * (" + cellsPerRowMobile + " - 1)) / " + cellsPerRowMobile + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
        }
        return "flex-basis: calc(100% / " + cellsPerRowMobile + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
    }
    if (cellsPerRowMobile === 1) {
        return "margin-bottom: " + rowGap + ";";
    }
    return null;
}, function (_a) {
    var cellsPerRowMobile = _a.cellsPerRowMobile;
    return cellsPerRowMobile;
}, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var cellsPerRowPercentage = _a.cellsPerRowPercentage;
    return cellsPerRowPercentage === 100 ? 'column' : 'row';
}, function (_a) {
    var cellsPerRowDesktop = _a.cellsPerRowDesktop, colGap = _a.colGap, rowGap = _a.rowGap;
    if (cellsPerRowDesktop > 1) {
        if (colGap !== '0') {
            return "flex-basis: calc((100% - " + colGap + " * (" + cellsPerRowDesktop + " - 1)) / " + cellsPerRowDesktop + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
        }
        return "flex-basis: calc(100% / " + cellsPerRowDesktop + "); margin-right: " + colGap + "; margin-bottom: " + rowGap + ";";
    }
    return "margin-bottom: " + rowGap + ";";
}, function (_a) {
    var cellsPerRowDesktop = _a.cellsPerRowDesktop;
    return cellsPerRowDesktop;
}, function (_a) {
    var alignment = _a.alignment;
    return alignment === 'left' &&
        "> div {\n        flex-basis: auto;\n    }";
});
var FlexBreak = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  height: 0;\n  flex-basis: 100% !important;\n"], ["\n  height: 0;\n  flex-basis: 100% !important;\n"])));
var Group = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var contentData = _a.contentData;
    var _o = contentData.field_cells_per_row, cellsPerRowDesktop = _o === void 0 ? contentData.paragraph
        ? contentData.paragraph.length
        : 0 : _o, _p = contentData.field_cells_per_row_mobile, cellsPerRowMobile = _p === void 0 ? Math.floor(cellsPerRowDesktop / 2) : _p, _q = contentData.field_col_gap, colGap = _q === void 0 ? '0' : _q, _r = contentData.field_row_gap, rowGap = _r === void 0 ? '0' : _r, _s = contentData.field_margin, outerMargin = _s === void 0 ? '0' : _s, _t = contentData.field_padding, outerPadding = _t === void 0 ? '0' : _t, _u = contentData.field_background_color, backgroundColor = _u === void 0 ? 'transparent' : _u, _v = contentData.field_alignment, alignment = _v === void 0 ? 'center' : _v, _w = contentData.field_vertical_alignment, verticalAlignment = _w === void 0 ? 'flex-start' : _w;
    var cellsPerRowPercentageMobile = 100 / cellsPerRowMobile;
    var cellsPerRowPercentage = 100 / cellsPerRowDesktop;
    var id = cuid();
    // this flex-break element and the counter are needed to force the flexbox to break
    // - it is used when the group elements should be left aligned while they do not fill the whole possible width
    var elementCounter = 0;
    var config = useConfig();
    return (React.createElement(StyledGroup, { className: "cms-group", "data-testid": "cms-group", key: "cms-group-" + id, outerMargin: outerMargin, outerPadding: outerPadding, backgroundColor: backgroundColor, alignment: alignment, verticalAlignment: verticalAlignment, cellsPerRowPercentage: cellsPerRowPercentage, cellsPerRowPercentageMobile: cellsPerRowPercentageMobile, cellsPerRowMobile: cellsPerRowMobile, colGap: colGap, rowGap: rowGap, cellsPerRowDesktop: cellsPerRowDesktop, justifyContent: (_c = (_b = config === null || config === void 0 ? void 0 : config.regExp) === null || _b === void 0 ? void 0 : _b.flex) === null || _c === void 0 ? void 0 : _c.justifyContent, alignContent: (_e = (_d = config === null || config === void 0 ? void 0 : config.regExp) === null || _d === void 0 ? void 0 : _d.flex) === null || _e === void 0 ? void 0 : _e.alignContent, alignSelf: (_g = (_f = config === null || config === void 0 ? void 0 : config.regExp) === null || _f === void 0 ? void 0 : _f.flex) === null || _g === void 0 ? void 0 : _g.alignSelf, textAlign: (_h = config === null || config === void 0 ? void 0 : config.regExp) === null || _h === void 0 ? void 0 : _h.textAlign, mobileMaxWidth: (_k = (_j = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _j === void 0 ? void 0 : _j.values) === null || _k === void 0 ? void 0 : _k.mobileMaxWidth, tabletMinWidth: (_m = (_l = config === null || config === void 0 ? void 0 : config.mediaBreakpoints) === null || _l === void 0 ? void 0 : _l.values) === null || _m === void 0 ? void 0 : _m.tabletMinWidth }, contentData.paragraph &&
        contentData.paragraph
            .filter(function (item) {
            return filterTimeControl(item);
        })
            .map(function (item) {
            var itemID = cuid();
            elementCounter += 1;
            return (React.createElement(Fragment, { key: itemID },
                React.createElement(ComponentRecognizer, { content: [item] }),
                alignment === 'left' && elementCounter % cellsPerRowDesktop === 0 && (React.createElement(FlexBreak, null))));
        })));
};
export default Group;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=index.js.map